import { render } from "./BenchMark.vue?vue&type=template&id=51673211&scoped=true"
import script from "./BenchMark.vue?vue&type=script&lang=js"
export * from "./BenchMark.vue?vue&type=script&lang=js"

import "./BenchMark.vue?vue&type=style&index=0&id=51673211&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51673211"]])

export default __exports__